



















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';
import { clone, cloneDeep, isString, merge } from 'lodash';
import cms from '@/store/modules/cms';
import Modal from '@/components/UI/Modal.vue';
import ShippingTimesMessage from '@/components/Shipping/Times.vue';
import {
    Address as AddressModel,
    Address,
    Agreement as AgreementModel,
    CartItem as CartItemModel,
    Country,
    QuoteAddress,
    ShippingInfoData,
    ShippingOption,
    ShippingOptions,
    ShippingTimes,
    Totals,
    TotalSegment,
    UserRegistrationRequest,
} from '@/store/models';
import addressNormalizer, {
    addExtensionAttributes,
    normalizeQuoteAddress,
    quoteAddressToCustomerAddress,
} from '@/commons/addressNormalizer';
import { decode as decodeShipment } from '@/commons/shipmentMethodHelpers';
import AddressList from '@/components/Address/List.vue';
import Agreement from '@/components/Cms/Agreement.vue';
import { err } from '@/commons/toast';
import store from '@/store';
import ui from '@/store/modules/ui';
import AddressForm from '@/components/Address/Form.vue';
import CartTotals from '@/components/Cart/Totals.vue';
import addressValidator from '@/commons/addressValidator';
import { assignEmailToQuote, userSaveData } from '@/store/api';
import gtmhelpers from '@/commons/gtmhelpers';
import handleError from '@/commons/errorHandler';
import device from '@/store/modules/device';
import redirectToLocation, { getFullUrl } from '@/commons/redirectManager';
import { hideHubSpotPopup, showHubSpotPopup } from '@/commons/hubspot';
import LoyaltyBenefits from '@/components/Checkout/LoyaltyBenefits.vue';
import handleMessage from '@/commons/messageManager';

@Component({
    components: {
        AddressList,
        Agreement,
        AddressForm,
        CartTotals,
        Modal,
        ShippingTimesMessage,
        LoyaltyBenefits,
    },
})
export default class ShippingStep extends Vue {
    private changeAddressFlag: boolean = false;
    private loading = false;
    private addressSelected = false;

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get hasAddresses(): boolean {
        return user.customer.addresses.length > 0;
    }

    get address(): QuoteAddress {
        return checkout.shippingAddress;
    }

    get agreements(): AgreementModel[] {
        return cms.agreements;
    }

    get countries(): Country[] {
        return store.state.countryData.countries;
    }

    get checkoutEmail(): string {
        return checkout.email;
    }

    set checkoutEmail(email: string) {
        checkout.setEmail(email);
    }

    get isChangeAddress() {
        return this.changeAddressFlag;
    }

    get items(): CartItemModel[] {
        return cart.cart.items;
    }

    get totals(): Totals {
        return cart.totals;
    }

    get isLoading(): boolean {
        return cart.loadingFlags.totals || this.loading;
    }

    get hasShippingMethodAvailable(): boolean {
        return checkout.selectedShipment !== '' && checkout.selectedShipment !== null;
    }

    get hasShippingMethodOptions(): boolean {
        return checkout.selectedShippingMethodOptions.length > 0;
    }

    get shippingMethodOptions(): ShippingOption[] {
        if (this.isSilverOrGoldGroup()) {
            this.changedSkipShippingLabel();
        }
        return checkout.selectedShippingMethodOptions;
    }

    get shippingMethodTimes(): ShippingTimes {
        return checkout.selectedShippingMethodTimes;
    }

    get isMobile() {
        return device.isMobile;
    }

    get getCustomerLoyaltyGroup() {
        let group = '';
        if (checkout.loyalty.customer_current_loyalty_group !== undefined) {
            group = checkout.loyalty.customer_current_loyalty_group.group_label;
        }

        return group;
    }

    public async addressFormSubmittedHandler(addressData: QuoteAddress) {
        const valid = await this.$validator.validateAll();

        if (valid) {
            this.saveNewAddress(addressData);
        }
    }

    public isSilverOrGoldGroup() {
        return this.getCustomerLoyaltyGroup === 'Silver' || this.getCustomerLoyaltyGroup === 'Gold';
    }

    public changedSkipShippingLabel() {
        const shippingOptions = checkout.selectedShippingMethodOptions;
        shippingOptions.map((option) => {
            if (option.code === 'skip') {
                option.label =
                    '“SALTA LA FILA PASSIONE CLUB”- Preparazione prioritaria, non usarlo se paghi con bonifico';
            }
            return shippingOptions;
        });
    }

    private mounted() {
        checkout.checkSingleShippingMethod(true);
        this.checkPayment();
        this.checkAddress();
        gtmhelpers.trackPageview(this.$router.currentRoute.fullPath);

        device.updateMobileDetection();

        // Show hubspot popup
        showHubSpotPopup();
    }

    private destroyed() {
        // Hide hubspot popup
        hideHubSpotPopup();
    }

    @Watch('address.country_id')
    private onCountryIdChange(val: any, oldVal: any) {
        if (val && oldVal && val !== oldVal && this.isChangeAddress) {
            this.address.region = '';
            this.address.region_id = 0;
        }
    }

    private checkPayment() {
        if (checkout.paymentMethods) {
            if (checkout.selectedPayment && !checkout.paymentMethods.find((m) => m.code === checkout.selectedPayment)) {
                checkout.setSelectedPayment('');
            }
        }
    }

    private checkAddress() {
        if (!this.changeAddressFlag) {
            if (checkout.selectedAddressId.shipping) {
                const errors = addressValidator(checkout.shippingAddress);

                if (errors.length > 0) {
                    if (this.isLogged) {
                        const link = getFullUrl(`/customer/address/edit/id/${checkout.selectedAddressId.shipping}/`);

                        err(
                            `${this.$t('Selected address has invalid fields').toString()}:<br>${errors.join(
                                ', ',
                            )}<br>${this.$t('<a href="{link}">Edit it</a> or insert/select another one', {
                                link,
                            }).toString()}`,
                        );
                    } else {
                        handleMessage('error', `${this.$t('Selected address has invalid fields').toString()}`);
                    }

                    user.setAddressError(checkout.selectedAddressId.shipping);

                    return false;
                }
            }
        }
        return true;
    }

    private changeAddress() {
        if (this.address.postcode && !this.hasAddresses) {
            this.address.postcode = '';
        }
        this.changeAddressFlag = !this.changeAddressFlag;

        if (this.changeAddressFlag) {
            this.addressSelected = false;
        } else {
            this.setAddressOnBack();
        }
    }

    private backToAddressSelection() {
        this.changeAddressFlag = false;
        this.setAddressOnBack();
    }

    private setAddressOnBack() {
        if (checkout.selectedAddressId.shipping) {
            let selectedAddress = this.getAddressFromCustomer(checkout.selectedAddressId.shipping);

            if (selectedAddress) {
                selectedAddress = addressNormalizer(selectedAddress);
                delete selectedAddress.id;
                this.addressSelectedHandler(selectedAddress);
            }
        }
    }

    private getAddressFromCustomer(id: number): Address | undefined {
        return user.customer.addresses.find((a) => a.id === id);
    }

    private isSelected(option: any) {
        if (option.code && option.code === 'notice') {
            return checkout.selectedShippingNotice;
        }

        if (option.code && option.code === 'skip') {
            return checkout.selectedShippingSkip;
        }

        return false;
    }

    private async changeShippingOption(option: ShippingOption) {
        await checkout.changeSelectedShippingOption({
            code: option.code,
            newStatus: !checkout.shippingOptions[option.code as keyof ShippingOptions].selected,
        });
    }

    private openModal(modalId: string) {
        ui.openModal(modalId);
    }

    private closeModal(modalId: string) {
        ui.closeModal(modalId);
    }

    private async addressSelectedHandler(address: any) {
        this.addressSelected = true;
        const differentCountry = address.country_id !== this.address.country_id;
        this.address.street = [''];
        merge(this.address, address);
        const addressClone = clone(this.address);
        const shippingInfoData: ShippingInfoData = {
            address: normalizeQuoteAddress(addressClone) as QuoteAddress,
            shippingmethod: decodeShipment(checkout.selectedShipment),
            removeOptions: differentCountry,
        };

        checkout
            .setShippingInfo(shippingInfoData)
            .then(() => {
                // checkout.setShippingAddress(address);
                checkout.checkSingleShippingMethod();
                checkout.getPaymentMethods(checkout.billingSameAsShipping ? address : checkout.billingAddress, address);
            })
            .catch(() => {
                redirectToLocation('/checkout/cart');
            });

        normalizeQuoteAddress(addressClone);
    }

    private async saveNewAddress(addressData: QuoteAddress) {
        this.loading = true;
        const oldAddressIds = user.customer.addresses.map((a) => a.id);
        const normalized = quoteAddressToCustomerAddress(addressData) as AddressModel;
        delete normalized.id;
        normalized.default_shipping = true;
        normalized.default_billing = true;
        user.resetAddressErrors();
        const userObj = cloneDeep(user.customer) as unknown as UserRegistrationRequest;

        for (const a of userObj.addresses) {
            a.default_shipping = false;
            a.default_billing = false;
        }

        let differentCountry = false;
        let selectedAddress = this.getAddressFromCustomer(checkout.selectedAddressId.shipping);

        if (selectedAddress) {
            selectedAddress = addressNormalizer(selectedAddress);
            differentCountry = selectedAddress.country_id !== normalized.country_id;
        }

        userObj.addresses.push(normalized);

        if (this.isLogged) {
            userSaveData(userObj)
                .then((res) => {
                    for (const a of res.addresses) {
                        if (!oldAddressIds.includes(a.id)) {
                            user.customer.addresses.push(addExtensionAttributes(a));
                            checkout.shippingAddress.customer_address_id = a.id;
                            checkout.setSelectedAddressId({ type: 'shipping', id: a.id });
                            break;
                        }
                    }

                    addressData.customer_address_id = checkout.selectedAddressId.shipping;
                })
                .catch((e) => {
                    this.loading = false;
                    handleError(e);
                });
        } else {
            user.customer.addresses.push(addExtensionAttributes(addressData));
            checkout.selectedAddressId.shipping = addressData.id;
        }

        this.addressSelected = true;
        this.changeAddressFlag = false;
        addressData.id = checkout.shippingAddress.id;
        checkout.setShippingAddress(addressData);

        const addressClone = clone(addressData);
        const shippingInfoData: ShippingInfoData = {
            address: normalizeQuoteAddress(addressClone) as QuoteAddress,
            shippingmethod: decodeShipment(checkout.selectedShipment),
            removeOptions: differentCountry,
        };

        checkout.setShippingInfo(shippingInfoData).finally(() => {
            checkout.checkSingleShippingMethod();
            checkout
                .getPaymentMethods(checkout.billingSameAsShipping ? addressData : checkout.billingAddress, addressData)
                .finally(() => {
                    this.loading = false;
                });
        });
        this.loading = false;
    }

    private async proceed(addressData: any) {
        this.setFreeShippingForZeroTotalCheckout();

        if (this.changeAddressFlag) {
            handleMessage('error', this.$t('Save new address to proceed').toString());

            return;
        }

        if (this.hasAddresses && !this.addressSelected) {
            handleMessage('error', this.$t('Select an address').toString());

            return;
        }

        if (this.isLogged && !this.addressSelected) {
            handleMessage('error', this.$t('Create new address to proceed').toString());

            return;
        }

        if (!this.isLogged && !this.isValidEmail(this.checkoutEmail)) {
            handleMessage('error', this.$t('Insert a valid email address to proceed').toString());

            return;
        }

        if (!this.checkAddress()) {
            return;
        }

        if (isString(addressData.region_id) && addressData.region_id === '') {
            addressData.region_id = 0;
        }

        const data: ShippingInfoData = {
            address: addressData,
            shippingmethod: decodeShipment(checkout.selectedShipment),
        };

        let prom: Promise<boolean>;

        if (this.checkoutEmail && !this.isLogged && this.checkoutEmail !== user.customer.email) {
            this.loading = true;
            prom = new Promise((resolve, reject) => {
                assignEmailToQuote(this.checkoutEmail)
                    .then(() => {
                        user.setEmail(this.checkoutEmail);
                        resolve(true);
                    })
                    .catch((e) => {
                        handleError(e, false);
                        reject(e);
                    });
            });
        } else {
            prom = new Promise((r) => {
                r(true);
            });
        }

        prom.then(async () => {
            checkout.setShippingAddress(addressData);
            this.loading = true;

            await checkout
                .setShippingInfo(data)
                .then(() => {
                    checkout.unlockStep('invoice');
                    checkout.unlockStep('confirm');
                    this.loading = false;
                    window.scroll(0, 0);
                    gtmhelpers.trackMethod('2', data.shippingmethod.method_code);

                    this.$router.push({ path: '/checkout/invoice' });
                })
                .catch((e: any) => {
                    const errResp = e.response.data;
                    if (
                        errResp.parameters &&
                        errResp.parameters.length === 2 &&
                        errResp.parameters[0] === 'matrixrate'
                    ) {
                        handleMessage('error', this.$t('Check zip code').toString());
                        this.$router.push({ path: '/' });
                    }
                });
        });
    }

    private setFreeShippingForZeroTotalCheckout() {
        if (checkout.paymentMethods !== null) {
            checkout.paymentMethods.forEach((paymentMethod) => {
                if (paymentMethod.code === 'free' && this.getGrandTotal(this.totals.total_segments) === 0) {
                    checkout.setPayment(paymentMethod.code).then(() => {
                        cart.flagLoading({ key: 'totals', value: true });
                        checkout.estimateShipping(checkout.defaultShippingAddress);
                        cart.flagLoading({ key: 'totals', value: false });
                    });
                }
            });
        }
    }

    private getGrandTotal(totalSegments: TotalSegment[]) {
        const grandTotal = totalSegments.find((total) => {
            return total.code === 'grand_total';
        });

        return grandTotal ? grandTotal.value : 0;
    }

    private created() {
        device.detectMobile();
    }

    private isValidEmail(email: string) {
        return /^[^@]+@\w+(\.\w+)+\w$/.test(email);
    }
}
